var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_26)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.987 2.5h11.258a1 1 0 0 1 .762 1.648L7.519 25.851l10.973-8.44a1 1 0 0 1 .61-.207h11.083c.89 0 1.337 1.077.707 1.707L20.785 29.018a1 1 0 0 1-.707.293H5.66a1 1 0 0 1-.955-.7L.78 16.05a1 1 0 0 1 .248-1.005L13.28 2.793a1 1 0 0 1 .707-.293z",
    fill: "#020000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.168 29.31h-.433a.65.65 0 0 1 0-1.296h.433a.65.65 0 0 1 0 1.297z",
    fill: "#020000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeek);
export default __webpack_public_path__ + "static/media/CEEK.9a3bbd535805e1888d19c84d6cfbb6be.svg";
export { ForwardRef as ReactComponent };